// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__kh24M","actions":"styles_actions__1Lk5H","skeleton_animate":"styles_skeleton_animate__2o_mE"};